import { combineReducers } from 'redux';
import { authAdminReducer } from './authAdminReducer';
import { authReducer } from './authReducer';
import { geolocationReducer } from './geolocationReducer';
import { languageReducer } from './languageReducer';
import { navigatorReducer } from './navigatorReducer';
import {materialUIDarkThemeReducer} from "./materialUIDarkThemeReducer";
import {materialUILightThemeReducer} from "./materialUILightThemeReducer";
import {configHanuThemeReducer} from "./configHanuThemeReducer";
import {profileReducer} from "./profileReducer";
import { partnerListReducer } from './partnersListReducer';

export const rootReducer = combineReducers({
    authAdmin: authAdminReducer,
    auth: authReducer,
    geolocation: geolocationReducer,
    language: languageReducer,
    navigator: navigatorReducer,
    profiles: profileReducer,
    materialUILightTheme: materialUILightThemeReducer,
    materialUIDarkTheme: materialUIDarkThemeReducer,
    configHanuTheme: configHanuThemeReducer,
    partnerList: partnerListReducer,
});
